import { render } from "./EditableText.vue?vue&type=template&id=48883ee8"
import script from "./EditableText.vue?vue&type=script&lang=js"
export * from "./EditableText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__